import { Chip, Tooltip } from '@mui/material';
import { useCreditsBalance } from '../../api/queries/credits';

/**
 * Top-bar credit balance chip. Clicking pops a tooltip listing recent transactions.
 * Polled lazily by TanStack Query; generation modals invalidate the query on success.
 */
export function CreditsBadge() {
  const { data, isLoading } = useCreditsBalance();
  if (isLoading) return <Chip size="small" label="credits…" />;
  if (!data) return null;

  const recent = data.recentTransactions.slice(0, 5);
  return (
    <Tooltip
      title={
        recent.length === 0 ? (
          'no transactions yet'
        ) : (
          <div>
            {recent.map((tx) => (
              <div key={tx.id}>
                {tx.amount >= 0 ? '+' : ''}
                {tx.amount} ({tx.kind}) → {tx.balanceAfter}
              </div>
            ))}
          </div>
        )
      }
    >
      <Chip
        size="small"
        color={data.balance > 0 ? 'success' : 'warning'}
        label={`${data.balance} credits`}
      />
    </Tooltip>
  );
}
